/**
 * Created by maximus on 29.11.16.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactBootstrap = require('react-bootstrap');

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _constants = require('./constants');

var _modal = require('redux/actions/modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ModalWindow: {
        displayName: 'ModalWindow'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Modal/ModalWindow.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var ModalWindow = _wrapComponent('ModalWindow')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        modal: state.modal
    };
}, {
    hide: _modal.hide,
    pushState: _reactRouterRedux.push
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(ModalWindow, _Component);

    function ModalWindow(props, context) {
        (0, _classCallCheck3.default)(this, ModalWindow);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalWindow.__proto__ || (0, _getPrototypeOf2.default)(ModalWindow)).call(this, props, context));

        _this.registerEvent = function (eventName, callback) {
            _this.events[eventName] = callback;
        };

        _this.onEntering = function () {
            if (_this.events.hasOwnProperty('onEntering') && (0, _isFunction2.default)(_this.events.onEntering)) {
                var _this$events;

                (_this$events = _this.events).onEntering.apply(_this$events, arguments);
            }
        };

        _this.handleSuccess = function () {
            _this.props.modal.onSuccess();
            _this.props.hide();
        };

        _this.handleClose = function () {
            _this.props.hide();
        };

        _this.onHide = function () {
            var pushState = _this.props.pushState;


            var REGEXP_ORDER_ROUTE = /(\/personal\/order\/)[\d]+/g;

            if (REGEXP_ORDER_ROUTE.test(location.pathname)) {
                pushState('/');
            }

            _this.props.hide();
        };

        _this.events = {};
        return _this;
    }

    (0, _createClass3.default)(ModalWindow, [{
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                registerEvent: this.registerEvent
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props$modal = this.props.modal,
                is_show = _props$modal.is_show,
                title = _props$modal.title,
                content = _props$modal.content,
                titleSuccess = _props$modal.titleSuccess,
                titleClose = _props$modal.titleClose,
                onSuccess = _props$modal.onSuccess,
                modalType = _props$modal.modalType,
                _props$modal$modalSet = _props$modal.modalSettings,
                modalSettings = _props$modal$modalSet === undefined ? {} : _props$modal$modalSet;

            var modalClass = 'modal';
            var settings = {};
            global.onwheel = undefined;
            var successBtn = null;
            var cancelBtn = _react3.default.createElement(
                _reactBootstrap.Button,
                { onClick: this.handleClose },
                titleClose
            );

            switch (modalType) {
                case _constants.ADD:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'success', onClick: this.handleSuccess },
                        titleSuccess
                    );
                    break;
                case _constants.DELETE:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'danger', onClick: this.handleSuccess },
                        titleSuccess
                    );
                    break;
                case _constants.EDIT:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'primary', onClick: this.handleSuccess },
                        titleSuccess
                    );
                    break;
                case _constants.INFO:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'info', onClick: this.handleSuccess },
                        titleSuccess
                    );
                    break;
                case _constants.SAVE:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'success', onClick: this.handleSuccess },
                        titleSuccess
                    );
                    break;
                case _constants.ADD_TO_CART:
                    modalClass = 'addtocart modal';
                    global.onwheel = function () {
                        _this2.props.hide();
                    };
                    break;
                case _constants.ALCOHOL_MODAL:
                    successBtn = _react3.default.createElement(
                        _reactBootstrap.Button,
                        { bsStyle: 'danger', onClick: this.props.modal.onSuccess },
                        'OK'
                    );
                    cancelBtn = null;
                    break;
                case _constants.MODIFIER_MODAL:
                    modalClass = 'addtocart modal';
                    // successBtn = <Button bsStyle="danger" onClick={this.props.modal.onSuccess}>OK</Button>;
                    cancelBtn = null;
                    break;
                case _constants.COUPON_SEARCH_MODAL:
                    // modalClass = 'addtocart modal';
                    // successBtn = <Button bsStyle="danger" onClick={this.props.modal.onSuccess}>OK</Button>;
                    cancelBtn = null;
                    break;
                case _constants.AUTH:
                    settings.dialogClassName = 'registration-and-auth-modal';
                    settings.onEntering = this.onEntering;
                    break;
                case _constants.AUTH_ONE_CLICK:
                    settings.dialogClassName = 'registration-and-auth-modal';
                    settings.onEntering = this.onEntering;
                    break;
                case _constants.REGISTRATION:
                    settings.dialogClassName = 'registration-and-auth-modal';
                    break;
                case _constants.CONFIRM_PHONE:
                    settings.dialogClassName = 'confirm-phone-modal';
                    break;
                case _constants.CONFIRM_CHANGE_PHONE:
                    settings.dialogClassName = 'confirm-change-phone-modal';
                    break;
                case _constants.CONFIRM_MAIL:
                    settings.dialogClassName = 'confirm-mail-modal';
                    break;
                case _constants.PASSWORD_CHANGE:
                    settings.dialogClassName = 'password-change-modal';
                    break;
                case _constants.CONFIRM_OLD_MAIL:
                    settings.dialogClassName = 'confirm-old-mail-modal';
                    break;
                case _constants.MAP_MODAL:
                    this.onHide = function () {
                        _this2.props.hide();
                    };
                    break;
                case _constants.SAVE_SUCCESS:
                    {
                        this.onHide = function () {
                            _this2.props.hide();
                        };
                        break;
                    }
            }

            return _react3.default.createElement(
                _reactBootstrap.Modal,
                (0, _extends3.default)({
                    show: is_show,
                    onHide: this.onHide,
                    backdrop: true,
                    keyboard: true,
                    bsClass: modalClass
                }, content, settings),
                _react3.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react3.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        ' ',
                        title
                    )
                ),
                _react3.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    content
                ),
                successBtn ? _react3.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    cancelBtn,
                    successBtn
                ) : null
            );
        }
    }]);
    return ModalWindow;
}(_react2.Component), _class2.propsType = {
    hide: _react2.PropTypes.func.isRequired,
    pushState: _react2.PropTypes.func.isRequired
}, _class2.childContextTypes = {
    registerEvent: _react2.PropTypes.func
}, _temp)) || _class));

exports.default = ModalWindow;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/ModalWindow.jsx
// module id = 1689
// module chunks = 0